module.exports = __webpack_public_path__ + "files/5969043e649017ebe41e79b0eb2fad96.png";